import { getTrackSample } from '../game/track'
import type { Track, Vec2 } from '../game/types'

const SECTOR_COLORS = ['#4df4ff', '#7c5cff', '#ff315f', '#ffb547'] as const

export interface CheckpointMarker {
  key: string
  sampleIndex: number
  position: Vec2
  heading: number
  accent: string
  beaconLateral: number
  beaconHeight: number
  roadStripeWidth: number
  roadStripeDepth: number
  roadStripeY: number
}

export function createCheckpointMarkers(track: Track): CheckpointMarker[] {
  return track.checkpoints.map((sampleIndex, checkpointIndex) => {
    const sample = getTrackSample(track, sampleIndex)
    return {
      key: `checkpoint-${checkpointIndex}`,
      sampleIndex,
      position: sample.position,
      heading: Math.atan2(sample.tangent.x, sample.tangent.y),
      accent: checkpointIndex === 0 ? '#f7fbff' : SECTOR_COLORS[Math.floor(checkpointIndex / 4) % 4],
      beaconLateral: track.width + 1.9,
      beaconHeight: checkpointIndex === 0 ? 3.2 : 2.65,
      roadStripeWidth: track.width * 2 - 1.6,
      roadStripeDepth: checkpointIndex === 0 ? 0.22 : 0.14,
      roadStripeY: 0.105,
    }
  })
}
